import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  content: {
    paddingLeft: '64px'
  }
});
